(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bb-best-sellers"] && !Shopify.designMode) return;
  try {
    
  class BBBestSellers {
    constructor(root) {
      this.root = root;
      this.scroller = root.querySelector('[data-bb-best-sellers-scroller]');
      this.cards = Array.from(root.querySelectorAll('[data-bb-best-sellers-card]'));
      this.prevButton = root.querySelector('[data-bb-best-sellers-prev]');
      this.nextButton = root.querySelector('[data-bb-best-sellers-next]');

      if (!this.scroller || this.cards.length === 0) return;

      this.prevButton?.addEventListener('click', () => this.scrollBy(-1));
      this.nextButton?.addEventListener('click', () => this.scrollBy(1));
      this.scroller.addEventListener('scroll', () => this.updateArrowState(), { passive: true });
      window.addEventListener('resize', () => this.updateArrowState());

      this.scroller.scrollLeft = 0;
      requestAnimationFrame(() => {
        this.scroller.scrollLeft = 0;
        this.updateArrowState();
      });
    }

    getTrackPaddingLeft() {
      return parseFloat(window.getComputedStyle(this.scroller).paddingLeft) || 0;
    }

    getCurrentIndex() {
      if (this.cards.length === 0) return 0;

      const anchor = this.scroller.getBoundingClientRect().left + this.getTrackPaddingLeft();
      let closestIndex = 0;
      let closestDistance = Number.POSITIVE_INFINITY;

      this.cards.forEach((card, index) => {
        const distance = Math.abs(card.getBoundingClientRect().left - anchor);
        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = index;
        }
      });

      return closestIndex;
    }

    scrollBy(direction) {
      const currentIndex = this.getCurrentIndex();
      const nextIndex = Math.min(
        this.cards.length - 1,
        Math.max(0, currentIndex + direction)
      );

      if (nextIndex === currentIndex) return;

      const targetCard = this.cards[nextIndex];
      if (!targetCard) return;

      const scrollerRect = this.scroller.getBoundingClientRect();
      const cardRect = targetCard.getBoundingClientRect();
      const delta = cardRect.left - (scrollerRect.left + this.getTrackPaddingLeft());

      this.scroller.scrollBy({
        left: delta,
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
      });
    }

    updateArrowState() {
      if (!this.prevButton || !this.nextButton) return;

      const currentIndex = this.getCurrentIndex();
      const maxScrollLeft = Math.max(0, this.scroller.scrollWidth - this.scroller.clientWidth);
      const atEnd = this.scroller.scrollLeft >= maxScrollLeft - 2;

      this.prevButton.disabled = currentIndex <= 0;
      this.nextButton.disabled = atEnd || currentIndex >= this.cards.length - 1;
    }
  }

  const initBBBestSellers = (container = document) => {
    container.querySelectorAll('[data-bb-best-sellers]').forEach((root) => {
      if (root.dataset.bbBestSellersReady === 'true') return;
      root.dataset.bbBestSellersReady = 'true';
      new BBBestSellers(root);
    });
  };

  initBBBestSellers();

  document.addEventListener('shopify:section:load', (event) => {
    initBBBestSellers(event.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bb-forge-masters"] && !Shopify.designMode) return;
  try {
    
  class BBForgeMasters {
    constructor(root) {
      this.root = root;
      this.carousel = root.querySelector('.bb-forge-masters__carousel');
      this.scroller = root.querySelector('[data-bb-forge-masters-scroller]');
      this.track = root.querySelector('[data-bb-forge-masters-track]');
      this.cards = Array.from(root.querySelectorAll('[data-bb-forge-masters-card]'));
      this.profilePanels = Array.from(root.querySelectorAll('[data-bb-forge-masters-profile-panel]'));
      this.backgroundLayers = Array.from(root.querySelectorAll('[data-bb-forge-masters-background-layer]'));
      this.backgroundLogoLayers = Array.from(root.querySelectorAll('[data-bb-forge-masters-background-logo]'));
      this.prevButton = root.querySelector('[data-bb-forge-masters-prev]');
      this.nextButton = root.querySelector('[data-bb-forge-masters-next]');
      this.sectionId = root.dataset.sectionId;
      this.resizeObserver = null;

      this.bindEvents();
      this.updateLayout();

      if (this.cards.length > 0) {
        this.selectCard(this.cards[0], { scroll: false, announce: false });
      }
    }

    bindEvents() {
      this.root.querySelectorAll('[data-bb-forge-masters-select]').forEach((button) => {
        button.addEventListener('click', () => {
          const card = button.closest('[data-bb-forge-masters-card]');
          if (card) this.selectCard(card, { scroll: true, announce: true });
        });
      });

      this.root.querySelectorAll('[data-bb-forge-masters-instagram]').forEach((link) => {
        link.addEventListener('click', (event) => {
          event.stopPropagation();
        });
      });

      if (this.prevButton) {
        this.prevButton.addEventListener('click', () => this.scrollByCard(-1));
      }

      if (this.nextButton) {
        this.nextButton.addEventListener('click', () => this.scrollByCard(1));
      }

      if (this.scroller) {
        this.scroller.addEventListener('scroll', () => this.updateArrowState(), { passive: true });
      }

      if (typeof ResizeObserver !== 'undefined' && this.scroller) {
        this.resizeObserver = new ResizeObserver(() => this.updateLayout());
        this.resizeObserver.observe(this.scroller);
        if (this.track) this.resizeObserver.observe(this.track);
      } else {
        window.addEventListener('resize', () => this.updateLayout(), { passive: true });
      }
    }

    selectCard(card, { scroll = true, announce = true } = {}) {
      const blockId = card.dataset.blockId;
      const index = Number(card.dataset.masterIndex);
      const name = card.dataset.masterName;

      this.cards.forEach((item) => {
        const isActive = item === card;
        item.classList.toggle('is-active', isActive);
        const button = item.querySelector('[data-bb-forge-masters-select]');
        if (button) button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });

      this.profilePanels.forEach((panel) => {
        const isActive = panel.dataset.blockId === blockId;
        panel.classList.toggle('is-active', isActive);
        panel.hidden = !isActive;
      });

      this.backgroundLayers.forEach((layer) => {
        layer.classList.toggle('is-active', layer.dataset.blockId === blockId);
      });

      this.backgroundLogoLayers.forEach((layer) => {
        layer.classList.toggle('is-active', layer.dataset.blockId === blockId);
      });

      if (scroll && this.scroller && !this.carousel?.classList.contains('bb-forge-masters__carousel--centered')) {
        this.scrollCardIntoView(card);
      }

      document.dispatchEvent(
        new CustomEvent('forge-master:select', {
          detail: {
            sectionId: this.sectionId,
            blockId,
            index,
            name,
            backgroundImage: card.dataset.backgroundImage || '',
            backgroundImageMobile: card.dataset.backgroundImageMobile || ''
          }
        })
      );

      this.updateArrowState();
    }

    needsScroll() {
      if (!this.scroller || !this.track) return false;
      return this.track.scrollWidth > this.scroller.clientWidth + 2;
    }

    updateLayout() {
      if (!this.carousel || !this.scroller || !this.track) return;

      this.carousel.classList.remove('bb-forge-masters__carousel--centered');

      if (this.prevButton) this.prevButton.hidden = true;
      if (this.nextButton) this.nextButton.hidden = true;

      let overflow = this.needsScroll();

      if (overflow && this.cards.length > 1 && this.prevButton && this.nextButton) {
        this.prevButton.hidden = false;
        this.nextButton.hidden = false;
        overflow = this.needsScroll();
      }

      if (!overflow) {
        this.carousel.classList.add('bb-forge-masters__carousel--centered');
        if (this.prevButton) this.prevButton.hidden = true;
        if (this.nextButton) this.nextButton.hidden = true;
      }

      this.updateArrowState();
    }

    updateArrowState() {
      if (!this.prevButton || !this.nextButton || !this.scroller) return;

      if (this.prevButton.hidden && this.nextButton.hidden) return;

      const activeIndex = this.getActiveIndex();

      this.prevButton.disabled = activeIndex <= 0;
      this.nextButton.disabled = activeIndex >= this.cards.length - 1;
    }

    getActiveIndex() {
      const activeCard = this.cards.find((card) => card.classList.contains('is-active'));
      const activeIndex = activeCard ? this.cards.indexOf(activeCard) : 0;
      return activeIndex === -1 ? 0 : activeIndex;
    }

    getCurrentIndex() {
      if (!this.scroller || this.cards.length === 0) return 0;

      const scrollerRect = this.scroller.getBoundingClientRect();
      const scrollerCenter = scrollerRect.left + scrollerRect.width / 2;
      let closestIndex = 0;
      let closestDistance = Number.POSITIVE_INFINITY;

      this.cards.forEach((card, index) => {
        const cardRect = card.getBoundingClientRect();
        const cardCenter = cardRect.left + cardRect.width / 2;
        const distance = Math.abs(cardCenter - scrollerCenter);

        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = index;
        }
      });

      return closestIndex;
    }

    scrollCardIntoView(card, smooth = true) {
      if (!this.scroller || !card) return;

      const scrollerRect = this.scroller.getBoundingClientRect();
      const cardRect = card.getBoundingClientRect();
      const targetScrollLeft =
        this.scroller.scrollLeft +
        (cardRect.left - scrollerRect.left) -
        (scrollerRect.width - cardRect.width) / 2;
      const maxScrollLeft = Math.max(0, this.scroller.scrollWidth - this.scroller.clientWidth);

      this.scroller.scrollTo({
        left: Math.min(maxScrollLeft, Math.max(0, targetScrollLeft)),
        behavior:
          smooth && !window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'smooth' : 'auto',
      });
    }

    scrollByCard(direction) {
      if (!this.scroller || this.cards.length === 0) return;

      const activeIndex = this.getActiveIndex();
      const targetIndex = Math.min(this.cards.length - 1, Math.max(0, activeIndex + direction));

      if (targetIndex === activeIndex) return;

      const targetCard = this.cards[targetIndex];

      if (!targetCard) return;

      this.selectCard(targetCard, { scroll: true, announce: true });
    }
  }

  const initBBForgeMasters = (container = document) => {
    container.querySelectorAll('[data-bb-forge-masters]').forEach((root) => {
      if (root.dataset.bbForgeMastersReady === 'true') return;
      root.dataset.bbForgeMastersReady = 'true';
      new BBForgeMasters(root);
    });
  };

  initBBForgeMasters();

  document.addEventListener('shopify:section:load', (event) => {
    initBBForgeMasters(event.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bb-hero-slideshow"] && !Shopify.designMode) return;
  try {
    
  class BBHeroSlideshow {
    constructor(root) {
      this.root = root;
      this.viewport = root.querySelector('[data-bb-hero-viewport]');
      this.track = root.querySelector('.bb-hero-slideshow__track');
      this.slides = Array.from(root.querySelectorAll('.bb-hero-slideshow__slide'));
      this.dots = Array.from(root.querySelectorAll('[data-bb-hero-dot]'));
      this.previous = root.querySelector('[data-bb-hero-prev]');
      this.next = root.querySelector('[data-bb-hero-next]');
      this.autoplay = root.dataset.autoplay === 'true';
      this.autoplaySpeed = Number(root.dataset.autoplaySpeed) || 4000;
      this.activeIndex = 0;
      this.realSlideCount = this.slides.length;
      this.pendingReset = false;
      this.resetTimer = null;
      this.scrollIdleTimer = null;
      this.timer = null;
      // Keep the poster as LCP: don't download/play hero video until after first paint.
      this.videoPlaybackUnlocked = false;
      this.mobileQuery = window.matchMedia('(max-width: 749px)');

      if (!this.viewport || this.slides.length < 1) return;

      this.createLoopClone();
      this.prepareVideos();
      this.scheduleVideoUnlock();

      this.previous?.addEventListener('click', () => this.goTo(this.activeIndex - 1));
      this.next?.addEventListener('click', () => this.goTo(this.activeIndex + 1));

      this.dots.forEach((dot) => {
        dot.addEventListener('click', () => this.goTo(Number(dot.dataset.index)));
      });

      this.viewport.addEventListener('scroll', () => this.requestUpdate(), { passive: true });
      this.viewport.addEventListener('scrollend', () => this.handleScrollEnd());
      this.root.addEventListener('pointerenter', () => this.stopAutoplay());
      this.root.addEventListener('pointerleave', () => this.startAutoplay());
      this.root.addEventListener('focusin', () => this.stopAutoplay());
      this.root.addEventListener('focusout', () => this.startAutoplay());
      document.addEventListener('visibilitychange', () => this.syncVideoPlayback());
      this.mobileQuery.addEventListener('change', () => this.syncVideoPlayback());

      this.update();
      this.startAutoplay();
    }

    prepareVideos() {
      this.root.querySelectorAll('.bb-hero-slideshow__video').forEach((video) => {
        video.removeAttribute('autoplay');
        video.autoplay = false;
        video.preload = 'none';
        video.setAttribute('preload', 'none');
        // Avoid competing with the poster for LCP priority.
        video.removeAttribute('fetchpriority');
      });
    }

    scheduleVideoUnlock() {
      const unlock = () => {
        if (this.videoPlaybackUnlocked) return;
        this.videoPlaybackUnlocked = true;
        this.syncVideoPlayback();
      };

      const arm = () => {
        if ('requestIdleCallback' in window) {
          window.requestIdleCallback(unlock, { timeout: 2500 });
        } else {
          window.setTimeout(unlock, 2000);
        }
      };

      if (document.readyState === 'complete') {
        arm();
      } else {
        window.addEventListener('load', arm, { once: true });
      }

      // If the shopper interacts earlier, unlock immediately.
      ['pointerdown', 'touchstart', 'keydown'].forEach((eventName) => {
        window.addEventListener(eventName, unlock, { once: true, passive: true });
      });
    }

    createLoopClone() {
      if (!this.track || this.realSlideCount < 2) return;

      const clone = this.slides[0].cloneNode(true);
      clone.classList.add('bb-hero-slideshow__slide--clone');
      clone.setAttribute('aria-hidden', 'true');
      clone.removeAttribute('id');
      clone.querySelectorAll('[id]').forEach((node) => node.removeAttribute('id'));
      clone.querySelectorAll('a, button, input, select, textarea, video').forEach((node) => {
        node.setAttribute('tabindex', '-1');
      });
      clone.querySelectorAll('video').forEach((video) => {
        video.pause();
        video.removeAttribute('autoplay');
        video.preload = 'none';
      });
      clone.querySelectorAll('.bb-hero-slideshow__media').forEach((media) => {
        media.classList.remove('is-video-ready');
      });
      this.track.appendChild(clone);
    }

    requestUpdate() {
      window.clearTimeout(this.scrollIdleTimer);
      this.scrollIdleTimer = window.setTimeout(() => this.handleScrollEnd(), 180);

      if (this.updateQueued) return;
      this.updateQueued = true;
      window.requestAnimationFrame(() => {
        this.updateQueued = false;
        this.update();
      });
    }

    update() {
      const rawIndex = Math.round(this.viewport.scrollLeft / this.viewport.clientWidth);
      const normalizedIndex = rawIndex >= this.realSlideCount ? 0 : rawIndex;
      this.activeIndex = Math.max(0, Math.min(normalizedIndex, this.realSlideCount - 1));

      this.dots.forEach((dot, dotIndex) => {
        dot.setAttribute('aria-current', dotIndex === this.activeIndex ? 'true' : 'false');
      });

      this.syncVideoPlayback();
    }

    syncVideoPlayback() {
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const pageHidden = document.visibilityState === 'hidden';

      this.slides.forEach((slide, index) => {
        slide.querySelectorAll('.bb-hero-slideshow__video').forEach((video) => {
          const media = video.closest('.bb-hero-slideshow__media');
          const replacedByMobileImage =
            this.mobileQuery.matches && media?.classList.contains('bb-hero-slideshow__media--mobile-image');
          const shouldPlay =
            this.videoPlaybackUnlocked &&
            index === this.activeIndex &&
            !reduceMotion &&
            !pageHidden &&
            !replacedByMobileImage;

          if (!shouldPlay) {
            video.preload = 'none';
            media?.classList.remove('is-video-ready');
            if (!video.paused) video.pause();
            return;
          }

          video.preload = 'auto';

          const markReady = () => media?.classList.add('is-video-ready');

          if (video.readyState >= 2 && !video.paused) {
            markReady();
          } else {
            video.addEventListener('playing', markReady, { once: true });
          }

          if (!video.paused) return;

          const playPromise = video.play();
          if (playPromise && typeof playPromise.catch === 'function') {
            playPromise.catch(() => {});
          }
        });
      });
    }

    goTo(index) {
      if (this.realSlideCount < 1) return;

      let targetIndex = index;

      if (index >= this.realSlideCount && this.realSlideCount > 1) {
        targetIndex = this.realSlideCount;
        this.pendingReset = true;
      } else if (index < 0) {
        targetIndex = this.realSlideCount - 1;
      }

      this.viewport.scrollTo({
        left: this.viewport.clientWidth * targetIndex,
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
      });

      if (this.pendingReset) {
        window.clearTimeout(this.resetTimer);
        this.resetTimer = window.setTimeout(() => this.handleScrollEnd(), 850);
      }
    }

    handleScrollEnd() {
      if (this.realSlideCount < 2) return;

      const rawIndex = Math.round(this.viewport.scrollLeft / this.viewport.clientWidth);
      if (!this.pendingReset && rawIndex < this.realSlideCount) return;

      this.pendingReset = false;
      window.clearTimeout(this.resetTimer);

      if (rawIndex >= this.realSlideCount) {
        this.jumpTo(0);
        this.update();
      }
    }

    jumpTo(index) {
      const previousBehavior = this.viewport.style.scrollBehavior;
      this.viewport.style.scrollBehavior = 'auto';
      this.viewport.scrollLeft = this.viewport.clientWidth * index;
      this.viewport.style.scrollBehavior = previousBehavior;
    }

    startAutoplay() {
      if (!this.autoplay || this.slides.length < 2 || this.timer) return;
      this.timer = window.setInterval(() => this.goTo(this.activeIndex + 1), this.autoplaySpeed);
    }

    stopAutoplay() {
      if (!this.timer) return;
      window.clearInterval(this.timer);
      this.timer = null;
    }
  }

  const initBBHeroSlideshows = (container = document) => {
    container.querySelectorAll('[data-bb-hero-slider]').forEach((root) => {
      if (root.dataset.bbHeroReady === 'true') return;
      root.dataset.bbHeroReady = 'true';
      new BBHeroSlideshow(root);
    });
  };

  initBBHeroSlideshows();

  document.addEventListener('shopify:section:load', (event) => {
    initBBHeroSlideshows(event.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bb-main-collection"] && !Shopify.designMode) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bb-product-in-action"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const MOBILE_MQ = '(max-width: 749px)';

    const roots = document.querySelectorAll('[data-bb-product-in-action]');

    roots.forEach((root) => {
      if (root.dataset.bbInActionReady === 'true') return;
      root.dataset.bbInActionReady = 'true';

      const track = root.querySelector('[data-bb-in-action-track]');
      const cards = [...root.querySelectorAll('[data-bb-in-action-card]')];
      const prevButton = root.querySelector('[data-bb-in-action-prev]');
      const nextButton = root.querySelector('[data-bb-in-action-next]');
      const dotsRoot = root.querySelector('[data-bb-in-action-dots]');
      const mediaQuery = window.matchMedia(MOBILE_MQ);
      const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      let currentIndex = 0;
      let dots = [];
      let isMuted = true;
      let playbackToken = 0;

      const muteButtons = [...root.querySelectorAll('[data-bb-in-action-mute]')];

      const getVideo = (card) => card?.querySelector('.bb-product-in-action__video');

      const applyMuteState = () => {
        root.classList.toggle('is-unmuted', !isMuted);
        const label = isMuted ? 'Unmute video' : 'Mute video';

        cards.forEach((card) => {
          const video = getVideo(card);
          if (!video) return;
          video.muted = isMuted;
          if (isMuted) {
            video.setAttribute('muted', '');
          } else {
            video.removeAttribute('muted');
            video.volume = 1;
          }
        });

        muteButtons.forEach((control) => {
          control.setAttribute('aria-label', label);
        });
      };

      const pauseAllVideos = (exceptCard = null) => {
        cards.forEach((card) => {
          if (card === exceptCard) return;
          const video = getVideo(card);
          if (!video) return;
          video.pause();
          card.classList.remove('is-playing');
        });
      };

      const playCard = async (card, { reset = false } = {}) => {
        if (!card || prefersReducedMotion) return;

        const video = getVideo(card);
        if (!video) return;

        const token = ++playbackToken;
        const index = cards.indexOf(card);
        if (index >= 0) currentIndex = index;

        pauseAllVideos(card);

        video.muted = isMuted;
        if (isMuted) {
          video.setAttribute('muted', '');
        } else {
          video.removeAttribute('muted');
          video.volume = 1;
        }

        if (reset) {
          try {
            video.currentTime = 0;
          } catch (_error) {
            // Ignore seek errors on unloaded media.
          }
        }

        try {
          await video.play();
          if (token !== playbackToken) {
            video.pause();
            return;
          }
          card.classList.add('is-playing');
        } catch (_error) {
          if (token !== playbackToken) return;
          card.classList.remove('is-playing');
        }
      };

      const playNextAfter = (card) => {
        if (!cards.length) return;

        const index = cards.indexOf(card);
        const nextIndex = index < 0 ? 0 : (index + 1) % cards.length;

        if (mediaQuery.matches) {
          goTo(nextIndex, { smooth: true, autoplay: true });
          return;
        }

        currentIndex = nextIndex;
        updateDots();
        playCard(cards[nextIndex], { reset: true });
      };

      const updateDots = () => {
        dots.forEach((dot, index) => {
          const isActive = index === currentIndex;
          dot.classList.toggle('is-active', isActive);
          dot.setAttribute('aria-selected', isActive ? 'true' : 'false');
          dot.tabIndex = isActive ? 0 : -1;
        });
      };

      const goTo = (index, { smooth = true, autoplay = true } = {}) => {
        if (!track || !cards.length) return;

        currentIndex = (index + cards.length) % cards.length;
        const card = cards[currentIndex];
        if (!card) return;

        pauseAllVideos();

        track.scrollTo({
          left: card.offsetLeft - track.offsetLeft,
          behavior: smooth ? 'smooth' : 'auto',
        });

        updateDots();

        if (autoplay && mediaQuery.matches) {
          playCard(card, { reset: true });
        }
      };

      const syncFromScroll = () => {
        if (!track || !cards.length || !mediaQuery.matches) return;

        const trackCenter = track.scrollLeft + track.clientWidth / 2;
        let closestIndex = 0;
        let closestDistance = Number.POSITIVE_INFINITY;

        cards.forEach((card, index) => {
          const cardCenter = card.offsetLeft - track.offsetLeft + card.clientWidth / 2;
          const distance = Math.abs(cardCenter - trackCenter);
          if (distance < closestDistance) {
            closestDistance = distance;
            closestIndex = index;
          }
        });

        if (closestIndex !== currentIndex) {
          currentIndex = closestIndex;
          pauseAllVideos(cards[currentIndex]);
          updateDots();
          playCard(cards[currentIndex], { reset: true });
        }
      };

      const buildDots = () => {
        if (!dotsRoot || cards.length < 2) return;

        dotsRoot.innerHTML = '';
        dots = cards.map((_, index) => {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'bb-product-in-action__dot';
          dot.setAttribute('role', 'tab');
          dot.setAttribute('aria-label', `Go to video ${index + 1}`);
          dot.addEventListener('click', () => goTo(index));
          dotsRoot.appendChild(dot);
          return dot;
        });

        updateDots();
      };

      const startDesktopPlaylist = () => {
        if (!cards.length || mediaQuery.matches) return;
        currentIndex = 0;
        updateDots();
        playCard(cards[0], { reset: true });
      };

      cards.forEach((card) => {
        const button = card.querySelector('[data-bb-in-action-play]');
        const video = getVideo(card);
        if (!button || !video) return;

        video.setAttribute('playsinline', '');
        video.loop = false;
        video.muted = isMuted;

        button.addEventListener('click', async () => {
          if (video.paused || video.ended) {
            await playCard(card, { reset: video.ended });
          } else {
            playbackToken += 1;
            video.pause();
            card.classList.remove('is-playing');
          }
        });

        video.addEventListener('ended', () => {
          card.classList.remove('is-playing');
          playNextAfter(card);
        });
      });

      muteButtons.forEach((control) => {
        control.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          isMuted = !isMuted;
          applyMuteState();
        });
      });

      applyMuteState();

      if (prevButton) {
        prevButton.addEventListener('click', () => goTo(currentIndex - 1));
      }

      if (nextButton) {
        nextButton.addEventListener('click', () => goTo(currentIndex + 1));
      }

      if (track) {
        let scrollTimeout;
        track.addEventListener(
          'scroll',
          () => {
            window.clearTimeout(scrollTimeout);
            scrollTimeout = window.setTimeout(syncFromScroll, 60);
          },
          { passive: true }
        );
      }

      buildDots();

      if (mediaQuery.matches) {
        goTo(0, { smooth: false, autoplay: true });
      } else {
        if (track) {
          track.scrollTo({ left: 0, behavior: 'auto' });
        }
        startDesktopPlaylist();
      }

      const handleViewportChange = () => {
        playbackToken += 1;
        pauseAllVideos();

        if (mediaQuery.matches) {
          goTo(currentIndex, { smooth: false, autoplay: true });
        } else {
          if (track) {
            track.scrollTo({ left: 0, behavior: 'auto' });
          }
          startDesktopPlaylist();
        }
      };

      if (typeof mediaQuery.addEventListener === 'function') {
        mediaQuery.addEventListener('change', handleViewportChange);
      } else if (typeof mediaQuery.addListener === 'function') {
        mediaQuery.addListener(handleViewportChange);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-announcement-bar"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.bbAnnouncementLocalizationReady) return;
    window.bbAnnouncementLocalizationReady = true;

    document.addEventListener('click', (event) => {
      const option = event.target.closest('[data-bb-announcement-localization-option]');
      if (!option) return;

      const form = option.closest('form');
      const fieldName = option.dataset.name;
      const fieldValue = option.dataset.value;
      const field = form?.querySelector(`input[name="${fieldName}"]`);

      if (!form || !field || !fieldName || !fieldValue) return;

      field.value = fieldValue;

      if (typeof form.requestSubmit === 'function') {
        form.requestSubmit();
        return;
      }

      form.submit();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-header"] && !Shopify.designMode) return;
  try {
    
  class BBCustomHeader {
    constructor(root) {
      this.root = root;
      this.bar = root.querySelector('.bb-custom-header__bar');
      this.details = root.querySelector('[data-bb-custom-header-details]');
      this.panel = root.querySelector('.bb-custom-header__panel');
      this.drilldown = root.querySelector('[data-bb-custom-header-drilldown]');
      this.drilldownPanels = Array.from(root.querySelectorAll('[data-bb-mobile-subpanel]'));
      this.drilldownOpenButtons = Array.from(root.querySelectorAll('[data-target]'));
      this.drilldownBackButtons = Array.from(root.querySelectorAll('[data-bb-drilldown-back]'));
      this.closeButtons = Array.from(root.querySelectorAll('[data-bb-custom-header-close]'));
      this.cartProxyButtons = Array.from(root.querySelectorAll('[data-bb-custom-header-cart-proxy]'));
      this.accordions = Array.from(root.querySelectorAll('[data-bb-custom-header-accordion]'));
      this.desktopItems = Array.from(root.querySelectorAll('[data-bb-desktop-menu-item]'));
      this.desktopMedia = window.matchMedia('(min-width: 1150px)');
      this.closeTimer = null;
      this.desktopCloseTimer = null;
      this.lockedScrollY = null;
      this.handleDocumentClick = this.handleDocumentClick.bind(this);
      this.handleKeydown = this.handleKeydown.bind(this);
      this.handleMenuToggle = this.handleMenuToggle.bind(this);
      this.handleMediaChange = this.handleMediaChange.bind(this);
      this.openDesktopItem = this.openDesktopItem.bind(this);
      this.scheduleDesktopClose = this.scheduleDesktopClose.bind(this);
      this.closeDesktopItems = this.closeDesktopItems.bind(this);
      this.handleDesktopPanelResize = this.handleDesktopPanelResize.bind(this);
      this.positionDesktopPanel = this.positionDesktopPanel.bind(this);
      this.updateOpenDesktopPanel = this.updateOpenDesktopPanel.bind(this);
      this.syncAccordions = this.syncAccordions.bind(this);
      this.syncBodyLock = this.syncBodyLock.bind(this);

      this.closeButtons.forEach((button) => {
        button.addEventListener('click', () => this.close());
      });

      this.cartProxyButtons.forEach((button) => {
        button.addEventListener('click', () => {
          const cartTrigger = this.root.querySelector('[data-testid="cart-drawer-trigger"]');
          this.close({ immediate: true });

          if (cartTrigger) {
            cartTrigger.click();
            return;
          }

          window.location.href = this.root.dataset.cartUrl || '/cart';
        });
      });

      this.drilldownOpenButtons.forEach((button) => {
        button.addEventListener('click', () => this.openDrilldownPanel(button.dataset.target));
      });

      this.drilldownBackButtons.forEach((button) => {
        button.addEventListener('click', () => this.closeDrilldownPanel());
      });

      this.desktopItems.forEach((item) => {
        const panel = item.querySelector('[data-bb-desktop-panel]');

        item.addEventListener('pointerenter', () => this.openDesktopItem(item));
        item.addEventListener('pointerleave', (event) => this.scheduleDesktopClose(item, event.relatedTarget));
        item.addEventListener('focusin', () => this.openDesktopItem(item));
        item.addEventListener('focusout', (event) => this.scheduleDesktopClose(item, event.relatedTarget));

        panel?.addEventListener('pointerenter', () => this.openDesktopItem(item));
        panel?.addEventListener('pointerleave', (event) => this.scheduleDesktopClose(item, event.relatedTarget));
      });

      this.syncAccordions();
      this.syncBodyLock();
      this.details?.addEventListener('toggle', this.handleMenuToggle);
      this.desktopMedia.addEventListener?.('change', this.handleMediaChange);
      window.addEventListener('resize', this.handleDesktopPanelResize);
      window.addEventListener('scroll', this.updateOpenDesktopPanel, { passive: true });
      document.addEventListener('click', this.handleDocumentClick);
      document.addEventListener('keydown', this.handleKeydown);
    }

    close({ immediate = false } = {}) {
      window.clearTimeout(this.closeTimer);
      this.closeDesktopItems();
      this.closeDrilldownPanel();
      this.unlockBodyScroll();

      if (!this.details) return;

      if (this.isDesktopMenu() || immediate) {
        this.details.removeAttribute('open');
        return;
      }

      this.closeTimer = window.setTimeout(() => {
        this.details.removeAttribute('open');
        this.closeTimer = null;
      }, 400);
    }

    handleDocumentClick(event) {
      if (this.root.contains(event.target)) return;

      this.closeDesktopItems();

      if (this.details?.open) {
        this.close();
      }
    }

    handleKeydown(event) {
      if (event.key !== 'Escape') return;

      this.closeDesktopItems();

      if (this.drilldown?.classList.contains('is-active')) {
        this.closeDrilldownPanel();
        return;
      }

      if (this.details?.open) {
        this.close();
      }
    }

    handleMenuToggle() {
      if (this.details?.open) {
        window.clearTimeout(this.closeTimer);
        this.closeTimer = null;
        this.closeDrilldownPanel();
        this.syncAccordions();
      }

      this.syncBodyLock();
    }

    handleMediaChange() {
      this.closeDesktopItems();
      this.closeDrilldownPanel();
      this.syncAccordions();
      this.syncBodyLock();
    }

    openDrilldownPanel(panelId) {
      if (!panelId || !this.drilldown) return;

      this.drilldownPanels.forEach((panel) => {
        panel.classList.toggle('is-active', panel.id === panelId);
      });

      this.drilldown.classList.add('is-active');
    }

    closeDrilldownPanel() {
      this.drilldown?.classList.remove('is-active');
      this.drilldownPanels.forEach((panel) => panel.classList.remove('is-active'));
    }

    isDesktopMenu() {
      return this.desktopMedia.matches;
    }

    getHeaderBottom() {
      return Math.round(this.bar.getBoundingClientRect().bottom);
    }

    resetDesktopPanelStyles(panel) {
      if (!panel) return;

      panel.style.removeProperty('left');
      panel.style.removeProperty('right');
      panel.style.removeProperty('top');
      panel.style.removeProperty('width');
      panel.style.removeProperty('min-width');
      panel.style.removeProperty('max-width');
    }

    positionDesktopPanel(item) {
      if (!this.isDesktopMenu() || !item || !this.bar) return;

      const panel = item.querySelector('[data-bb-desktop-panel]');
      if (!panel) return;

      const isShop = item.classList.contains('bb-custom-header__desktop-item--shop');
      const headerBottom = this.getHeaderBottom() + 1;

      panel.style.top = `${headerBottom}px`;

      if (isShop) {
        panel.style.left = '0';
        panel.style.right = '0';
        panel.style.width = '100%';
        panel.style.minWidth = '';
        panel.style.maxWidth = '';
        return;
      }

      const itemRect = item.getBoundingClientRect();
      panel.style.left = `${Math.max(0, Math.round(itemRect.left))}px`;
      panel.style.right = 'auto';
      panel.style.width = 'max-content';
      panel.style.minWidth = '220px';
      panel.style.maxWidth = '360px';
    }

    updateOpenDesktopPanel() {
      const openItem = this.desktopItems.find((item) => item.classList.contains('is-open'));
      if (openItem) this.positionDesktopPanel(openItem);
    }

    handleDesktopPanelResize() {
      this.updateOpenDesktopPanel();
    }

    openDesktopItem(item) {
      if (!this.isDesktopMenu()) return;

      window.clearTimeout(this.desktopCloseTimer);
      this.desktopCloseTimer = null;

      this.desktopItems.forEach((currentItem) => {
        if (currentItem === item) return;

        currentItem.classList.remove('is-open');
        this.resetDesktopPanelStyles(currentItem.querySelector('[data-bb-desktop-panel]'));
      });

      item.classList.add('is-open');
      window.requestAnimationFrame(() => {
        this.positionDesktopPanel(item);
      });
    }

    scheduleDesktopClose(item, nextTarget) {
      if (!this.isDesktopMenu()) return;
      if (nextTarget instanceof Node && item.contains(nextTarget)) return;

      window.clearTimeout(this.desktopCloseTimer);
      this.desktopCloseTimer = window.setTimeout(() => {
        const panel = item.querySelector('[data-bb-desktop-panel]');
        const itemHasFocus = item.contains(document.activeElement);

        if (item.matches(':hover') || panel?.matches(':hover') || itemHasFocus) return;

        item.classList.remove('is-open');
        this.resetDesktopPanelStyles(panel);
        this.desktopCloseTimer = null;
      }, 180);
    }

    closeDesktopItems() {
      window.clearTimeout(this.desktopCloseTimer);
      this.desktopCloseTimer = null;
      this.desktopItems.forEach((item) => {
        const panel = item.querySelector('[data-bb-desktop-panel]');
        item.classList.remove('is-open');
        this.resetDesktopPanelStyles(panel);
      });
    }

    isCartDrawerOpen() {
      return Boolean(document.querySelector('cart-drawer-component dialog[open]'));
    }

    lockBodyScroll() {
      if (this.lockedScrollY !== null) return;

      this.lockedScrollY = window.scrollY;
      document.body.classList.add('menu-open');
      document.body.style.width = '100%';
      document.body.style.position = 'fixed';
      document.body.style.top = `-${this.lockedScrollY}px`;
    }

    unlockBodyScroll() {
      document.body.classList.remove('menu-open');

      if (this.isCartDrawerOpen()) {
        this.lockedScrollY = null;
        return;
      }

      if (this.lockedScrollY === null) {
        document.body.style.width = '';
        document.body.style.position = '';
        document.body.style.top = '';
        return;
      }

      const scrollY = this.lockedScrollY;
      this.lockedScrollY = null;
      document.body.style.width = '';
      document.body.style.position = '';
      document.body.style.top = '';
      window.scrollTo({ top: scrollY, behavior: 'instant' });
    }

    syncBodyLock() {
      const shouldLock = Boolean(this.details?.open && !this.isDesktopMenu());

      if (shouldLock) {
        this.lockBodyScroll();
        return;
      }

      this.unlockBodyScroll();
    }

    syncAccordions() {
      this.accordions.forEach((accordion) => {
        if (this.isDesktopMenu()) {
          accordion.setAttribute('open', '');
          return;
        }

        if (accordion.dataset.mobileDefaultOpen === 'true') {
          accordion.setAttribute('open', '');
          return;
        }

        accordion.removeAttribute('open');
      });
    }
  }

  const initBBCustomHeaders = (container = document) => {
    container.querySelectorAll('[data-bb-custom-header]').forEach((root) => {
      if (root.dataset.bbCustomHeaderReady === 'true') return;
      root.dataset.bbCustomHeaderReady = 'true';
      new BBCustomHeader(root);
    });
  };

  initBBCustomHeaders();

  document.addEventListener('shopify:section:load', (event) => {
    initBBCustomHeaders(event.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-bb"] && !Shopify.designMode) return;
  try {
    
  class HeroSlideshow extends HTMLElement {
    connectedCallback() {
      this.slides  = Array.from(this.querySelectorAll('[data-slide]'));
      this.dots    = Array.from(this.querySelectorAll('[data-dot]'));
      this.current = 0;
      this.total   = this.slides.length;
      this.timer   = null;

      if (this.total < 2) return; // Single slide — nothing to wire up

      this.autoplayDelay   = parseInt(this.dataset.autoplaySpeed || 5000, 10);
      this.shouldAutoplay  = this.dataset.autoplay === 'true';

      // Arrow buttons
      this.querySelector('[data-prev]')?.addEventListener('click', () => {
        this.goTo(this.current - 1);
        this.resetAutoplay();
      });
      this.querySelector('[data-next]')?.addEventListener('click', () => {
        this.goTo(this.current + 1);
        this.resetAutoplay();
      });

      // Dot buttons
      this.dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          this.goTo(parseInt(dot.dataset.dot, 10));
          this.resetAutoplay();
        });
      });

      // Keyboard navigation (left/right arrows)
      this.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft')  { this.goTo(this.current - 1); this.resetAutoplay(); }
        if (e.key === 'ArrowRight') { this.goTo(this.current + 1); this.resetAutoplay(); }
      });

      // Touch/swipe support
      this._touchStartX = null;
      this.addEventListener('touchstart', (e) => {
        this._touchStartX = e.touches[0].clientX;
      }, { passive: true });
      this.addEventListener('touchend', (e) => {
        if (this._touchStartX === null) return;
        const delta = e.changedTouches[0].clientX - this._touchStartX;
        this._touchStartX = null;
        if (Math.abs(delta) < 40) return; // Ignore tiny swipes
        if (delta < 0) this.goTo(this.current + 1);
        else           this.goTo(this.current - 1);
        this.resetAutoplay();
      }, { passive: true });

      // Pause on hover / focus within
      this.addEventListener('mouseenter', () => clearInterval(this.timer));
      this.addEventListener('mouseleave', () => { if (this.shouldAutoplay) this.startAutoplay(); });
      this.addEventListener('focusin',    () => clearInterval(this.timer));
      this.addEventListener('focusout',   () => { if (this.shouldAutoplay) this.startAutoplay(); });

      // Start
      if (this.shouldAutoplay) this.startAutoplay();

      // Theme editor: re-select active slide when block is selected
      document.addEventListener('shopify:block:select', (e) => {
        const slide = e.target.closest('[data-slide]');
        if (!slide) return;
        const index = this.slides.indexOf(slide);
        if (index !== -1) { clearInterval(this.timer); this.goTo(index); }
      });
    }

    goTo(index) {
      // Wrap around
      const next = ((index % this.total) + this.total) % this.total;
      if (next === this.current) return;

      // Outgoing
      const outgoing = this.slides[this.current];
      outgoing.classList.remove('hero__slide--active');
      outgoing.setAttribute('aria-hidden', 'true');
      this.dots[this.current]?.classList.remove('hero__dot--active');
      this.dots[this.current]?.setAttribute('aria-selected', 'false');

      // Pause outgoing video
      outgoing.querySelector('video')?.pause();

      // Incoming
      this.current = next;
      const incoming = this.slides[this.current];
      incoming.classList.add('hero__slide--active');
      incoming.setAttribute('aria-hidden', 'false');
      this.dots[this.current]?.classList.add('hero__dot--active');
      this.dots[this.current]?.setAttribute('aria-selected', 'true');

      // Play incoming video (muted, so autoplay won't be blocked)
      const video = incoming.querySelector('video');
      if (video) video.play().catch(() => {});
    }

    startAutoplay() {
      clearInterval(this.timer);
      this.timer = setInterval(() => this.goTo(this.current + 1), this.autoplayDelay);
    }

    resetAutoplay() {
      if (this.shouldAutoplay) this.startAutoplay();
    }

    disconnectedCallback() {
      clearInterval(this.timer);
    }
  }

  if (!customElements.get('hero-slideshow')) {
    customElements.define('hero-slideshow', HeroSlideshow);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
